var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[(_vm.appConfig)?_c(_vm.temp,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }